import Table from "./Table"
import Tr from "./Tr"
import Td from "./Td"

export default Table
export {
  Tr,
  Td
}
